import { render, staticRenderFns } from "./newPage.vue?vue&type=template&id=0c62956d&scoped=true"
import script from "./newPage.vue?vue&type=script&lang=js"
export * from "./newPage.vue?vue&type=script&lang=js"
import style0 from "./newPage.vue?vue&type=style&index=0&id=0c62956d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c62956d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c62956d')) {
      api.createRecord('0c62956d', component.options)
    } else {
      api.reload('0c62956d', component.options)
    }
    module.hot.accept("./newPage.vue?vue&type=template&id=0c62956d&scoped=true", function () {
      api.rerender('0c62956d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mallManagement/pageSetting/newPage.vue"
export default component.exports